exports = module.exports = require("../../../../../../../web-ai-translation/node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../../../web-ai-translation/node_modules/css-loader/index.js??ref--8-oneOf-1-1!../../../../../../../web-ai-translation/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../../../web-ai-translation/node_modules/postcss-loader/src/index.js??ref--8-oneOf-1-2!bootstrap/dist/css/bootstrap.css"), "");

// module
exports.push([module.id, ".nav-divider[data-v-9afd337c]{width:100%;display:block;height:1px;margin:16px 0;background:linear-gradient(90deg,transparent,rgba(0,229,255,.5) 20%,rgba(0,229,255,.5) 80%,transparent);box-shadow:0 0 8px rgba(0,229,255,.3);border:none}", ""]);

// exports
